import React from 'react';
import './TrackingModal.css';

const TrackingModal = ({ isOpen, onClose, order, orderStatusSystem, loading = false }) => {
  if (!isOpen || !order) return null;

  const renderOrderTracking = () => {
    return (
      <div className="tracking-timeline">
        <div className="timeline-container">
          {Object.keys(orderStatusSystem).slice(0, 8).map((status, index) => {
            const statusInfo = orderStatusSystem[status];
            const isCompleted = order.trackingSteps.includes(status);
            const isCurrent = order.status === status;
            
            return (
              <div 
                key={status} 
                className={`timeline-step ${isCompleted ? 'completed' : ''} ${isCurrent ? 'current' : ''}`}
              >
                <div className="step-icon" style={{ color: isCompleted ? statusInfo.color : '#ccc' }}>
                  <i className={statusInfo.icon}></i>
                </div>
                <div className="step-content">
                  <div className="step-title">{status}</div>
                  <div className="step-time">
                    {isCompleted && (
                      status === 'Delivered' && order.deliveredDate 
                        ? `Delivered on ${new Date(order.deliveredDate).toLocaleDateString()}`
                        : status === 'Order Placed' 
                        ? `Placed on ${new Date(order.date).toLocaleDateString()}`
                        : 'Completed'
                    )}
                  </div>
                </div>
                {index < 7 && <div className={`timeline-line ${isCompleted ? 'completed' : ''}`}></div>}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="tracking-modal-overlay" onClick={onClose}>
      <div className="tracking-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tracking-modal-header">
          <div className="tracking-header-content">
            <div className="tracking-icon">
              <i className="fas fa-shipping-fast"></i>
            </div>
            <div className="tracking-title">
              <h3>Order Tracking</h3>
              <p className="order-number">{order.orderNumber}</p>
            </div>
          </div>
          <button className="close-modal" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>
        
        <div className="tracking-modal-content">
          {loading && (
            <div className="tracking-modal-loading">
              <i className="fas fa-spinner fa-spin"></i>
              <span>Refreshing order status...</span>
            </div>
          )}
          <div className="order-summary">
            <div className="summary-item">
              <span className="label">Order Date:</span>
              <span className="value">{new Date(order.date).toLocaleDateString('en-GB')}</span>
            </div>
            <div className="summary-item">
              <span className="label">Current Status:</span>
              <span className={`status-value ${order.status.toLowerCase()}`}>
                {order.status}
              </span>
            </div>
            {order.deliveredDate && (
              <div className="summary-item">
                <span className="label">Delivered Date:</span>
                <span className="value">{new Date(order.deliveredDate).toLocaleDateString('en-GB')}</span>
              </div>
            )}
            <div className="summary-item">
              <span className="label">Total Amount:</span>
              <span className="value">Rs. {order.total.toLocaleString()}</span>
            </div>
          </div>

          <div className="tracking-section">
            <h4>Tracking Timeline</h4>
            {renderOrderTracking()}
          </div>

          <div className="order-items-summary">
            <h4>Order Items</h4>
            <div className="items-list">
              {order.items.map((item, index) => (
                <div key={index} className="modal-item">
                  <img src={item.image} alt={item.name} className="modal-item-image" />
                  <div className="modal-item-details">
                    <h5>{item.name}</h5>
                    <p>Size: {item.size} | Color: {item.color} | Qty: {item.quantity}</p>
                    <span className="modal-item-price">Rs. {item.price.toLocaleString()}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="tracking-modal-footer">
          <button className="close-tracking-btn" onClick={onClose}>
            <i className="fas fa-check"></i>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrackingModal; 